import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import RestaurantLayout from 'layout/Restaurant';
import { Navigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const RestaurantWorkers = Loadable(lazy(() => import('pages/restaurant/workers')));
const RestaurantRequests = Loadable(lazy(() => import('pages/restaurant/requests')));
const WorkerDetails = Loadable(lazy(() => import('pages/restaurant/worker-details')));
const RestaurantReservations = Loadable(lazy(() => import('pages/restaurant/reservations')));
const WaiterRequests = Loadable(lazy(() => import('pages/restaurant/waiter-requests')));
const CustomerRequests = Loadable(lazy(() => import('pages/restaurant/customer-requests')));
const RestaurantShifts = Loadable(lazy(() => import('pages/restaurant/shifts')));
const RestaurantTables = Loadable(lazy(() => import('pages/restaurant/tables')));
const RestaurantQrCodes = Loadable(lazy(() => import('pages/restaurant/qr-codes')));
const RestaurantSettings = Loadable(lazy(() => import('pages/restaurant/settings')));
const RestaurantSearch = Loadable(lazy(() => import('pages/restaurant/search')));
const ChangePassword = Loadable(lazy(() => import('pages/restaurant/change-password')));

// ==============================|| RESTAURANT ROUTING ||============================== //

const RestaurantRoutes = {
  path: '/restaurant',
  children: [
    {
      path: '/restaurant/',
      element: <RestaurantLayout onlySpanish />,
      children: [
        {
          index: true,
          element: <Navigate to="workers" replace />
        },
        {
          path: 'workers',
          element: <RestaurantWorkers />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'reservations',
          element: <RestaurantReservations />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'waiter-requests',
          element: <WaiterRequests />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'customer-requests',
          element: <CustomerRequests />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'shifts',
          element: <RestaurantShifts />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'tables',
          element: <RestaurantTables />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'qr-codes',
          element: <RestaurantQrCodes />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'requests',
          element: <RestaurantRequests />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'search',
          children: [
            {
              index: true,
              element: <RestaurantSearch />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'worker-details/:id',
              element: <WorkerDetails />,
              errorElement: <ErrorBoundary />
            }
          ]
        },
        {
          path: 'settings',
          children: [
            {
              index: true,
              element: <RestaurantSettings />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'change-password',
              element: <ChangePassword />,
              errorElement: <ErrorBoundary />
            }
          ]
        }
      ]
    }
  ]
};

export default RestaurantRoutes;
